import { Country } from "../models/common/country.model";
import { GeoAddress } from "../models/common/geo-address.model";
import { LatLng } from "../models/common/lat-lng";
import { Company } from "../company/company.model";
import { Customer } from "../customer/customer.model";
import { CrmAccount, CrmClient, CrmMerchandiser } from "../crm/crm.model";
import { AuditActorSummary } from '../shared/audit/audit.models';

export interface LocationMerchandiserAssignment {
    id?: number;
    crmClientId?: number;
    crmClient?: CrmClient;
    crmAccountId?: number;
    crmAccount?: CrmAccount;
    merchandiserId?: number;
    merchandiser?: CrmMerchandiser;
    accessRole?: string;
    primaryMerchandiser?: boolean;
    active?: boolean;
}

export interface LocationRetailer {
    id?: number;
    owningCompanyId?: number;
    name?: string;
    active?: boolean;
    createdAt?: Date | string;
    updatedAt?: Date | string;
}


export class Location {

    id: number;
    address: GeoAddress;
    addressText?: string;
    countryId?: number;
    cityId?: number;
    locationZoneId?: number;
    district?: string;
    country: Country;
    company: Company;
    retailer?: LocationRetailer;
    defaultContact: Customer;
    contacts: Customer[];
    merchandisers: CrmMerchandiser[];
    merchandiserAssignments?: LocationMerchandiserAssignment[];
    location: LatLng;
    name: string;
    longDescription: string;
    shortDescription: string;
    telephoneNumber: string | null;
    placeId: string;
    managedBy: Company;
    roomNumber: string;
    floorNumber: string;
    buildingNumber: string;
    nearbyLandmark: string;
    frontDoorImage: string;
    buildingImage: string | null;
    isWarehouse: boolean;
    locationType: string;
    helperImage1: string | null;
    helperImage2: string | null;
    helperImage3: string | null;
    externalLocationReference: string;
    createdBy?: number;
    createdAt?: Date | string;
    createdByActor?: AuditActorSummary;
    updatedBy?: number;
    updatedAt?: Date | string;
    updatedByActor?: AuditActorSummary;
    deletedBy?: number;
    deletedAt?: Date | string;

}
